import React from 'react'
import { Card, Typography } from 'antd'

const { Title } = Typography

const Gantt: React.FC = () => {
  return (
    <div className="fade-in">
      <Title level={2}>甘特图</Title>
      <Card>
        <p>甘特图功能正在开发中...</p>
      </Card>
    </div>
  )
}

export default Gantt